{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Valitse kohde",
  "tableResizer": "Koon muuttaja"
}
